import { useState, useCallback } from "react";
import { api } from "@/lib/api-client";

// ═══════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════

export interface DirectoryImportResult {
  message: string;
  batchName: string;
  fileCount: number;
}

// ═══════════════════════════════════════════════════════════════
// Hook
// ═══════════════════════════════════════════════════════════════

export function useDirectoryImport() {
  const [isImporting, setIsImporting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [lastResult, setLastResult] = useState<DirectoryImportResult | null>(null);

  const importDirectory = useCallback(async (params: {
    path: string;
    jobTypeId?: string;
    manifestMode?: "none" | "optional" | "required";
    manifestFilename?: string;
  }): Promise<DirectoryImportResult> => {
    setIsImporting(true);
    setError(null);
    try {
      const result = await api.post<DirectoryImportResult>("/ingest/directory", params);
      setLastResult(result);
      return result;
    } catch (e) {
      const msg = e instanceof Error ? e.message : "Import failed";
      setError(msg);
      throw e;
    } finally {
      setIsImporting(false);
    }
  }, []);

  return { importDirectory, isImporting, error, lastResult };
}
